import { ref, watch } from 'vue'
import { useChatsStore } from '@/stores/chats.store'

export default function useList() {
  const listTable = ref([])

  const searchQuery = ref('')
  const options = ref({
    page: ref(1),
    itemsPerPage: 250,
  })
  const totalListTable = ref(0)
  const loading = ref(true)
  const nbPages = ref(0)
  const page = ref(1)
  const chatsStore = useChatsStore()
  const fetchDatas = () => {
    loading.value = true
    listTable.value = []
    chatsStore
      .getMessages({
        chatId: chatsStore.chat.id,
        search: searchQuery.value,
        options: { page: page.value, itemsPerPage: 250 },
      })
      .then(data => {
        if (!data) return
        listTable.value = data.data
        totalListTable.value = data.count
        nbPages.value = Math.ceil(totalListTable.value / options.value.itemsPerPage)
        loading.value = false
      })
      .catch(() => {
        listTable.value = []
        totalListTable.value = 0
        nbPages.value = 0
        loading.value = false
      })
  }
  fetchDatas()
  watch([searchQuery, page], () => {
    fetchDatas()
  })

  return {
    searchQuery,
    page,
    listTable,
    totalListTable,
    loading,
    fetchDatas,
    nbPages,
  }
}
